<template>
  <div class="  d-lg-flex py-2 align-items-center justify-content-around shadow">
    
    <!-- Partner Logos -->
    <div class="bg-white rounded-3 px-3 py-2 d-flex flex-column align-items-center" style="width: fit-content;">
      <div class="gap-3">
        <img 
          src="../assets/stk/Layer 18.png" 
          alt="Alliance Bioversity & CIAT" 
          class="partner-logo img-fluid"
          style="max-height: 50px;"
        />
        <img 
          src="../assets/stk/Layer 3.png" 
          alt="CSIR Ghana" 
          class="partner-logo img-fluid"
          style="max-height: 50px;"
        />
      </div>
    </div>
    <!-- select a crop  -->
    <div class="border-start border-2 border-danger ps-1 " style="width:fit-content">
      <select class="form-select  rounded-2 mb-1" style="width: 250px;font-size:13px" id="inputGroupSelect01" v-model="onSelectedCrop"
        >
        <option selected value="default">Select CropType</option>
        <option v-for="(res, i) in crops" :key="i" :value="res.crop_id">{{ res.crop }}</option>
      </select>
      <VueDatePicker v-model="onSelectedPlantingDate" week-picker  auto-apply placeholder="(Optional) Planting Week" />
    </div>
    <!-- Year and Language Selectors -->  
     <!-- comething chabed fhhfh-->
    <div class="border-start border-2 border-danger ps-1" style="width:fit-content">
      <select class="form-select rounded-2 mb-1" style="width: 250px;font-size:13px" v-model="onSelectedYear">
        <option :value="new Date().getFullYear() - 1">{{ new Date().getFullYear() - 1 }}</option>
        <option :value="new Date().getFullYear()">{{ new Date().getFullYear() }} (Current)</option>
        <option :value="new Date().getFullYear() + 1">{{ new Date().getFullYear() + 1 }}</option>
        <option :value="new Date().getFullYear() + 2">{{ new Date().getFullYear() + 2 }}</option>
      </select>
      <select class="form-select rounded-2" style="width: 250px;font-size:13px" v-model="onSelectedLanguage">
        <option :value="null">Language (Auto)</option>
        <option v-for="lang in languages" :key="lang.language_id" :value="lang.language_id">
          {{ lang.language_name }}
        </option>
      </select>
    </div>
    <div v-if="crop">
      <div class=" border-end border-2 pe-1 mt-2 border-danger" style="width:fit-content">
        <!-- select a region -->
        <select class="form-select"  style="width: 250px;font-size:13px" v-model="onSelectedRegion" >
          <option value="default">Choose Region</option>
          <option v-for="(res, i) in regions" :key="i" :value="res.region_id">{{ res.region }}</option>
        </select>
        <!-- select a district -->
        <select v-if="region" class="form-select  rounded-3 mt-1" style="width: 250px;font-size:13px" id="inputGroupSelect01"
          v-model="onSelectedDistrict">
          <option selected value="default">Change District</option>
          <option v-for="(res, i) in districts" :key="i" :value="res.district_id">{{ res.district }}</option>
        </select>
      </div>
      <p class="text-danger" style="font-size:13px" v-if="errMsg"><i class="bi bi-exclamation-circle"></i> {{ errMsg }}
      </p>
    </div>

    <div>
      <button style="font-size:12px my-3" data-bs-toggle="offcanvas" v-if="region" data-bs-target="#resources"
        class="btn btn-danger btn-sm rounded-4 mt-1 w-100"><i class="bi me-1 bi-bootstrap-reboot"></i>
        Resources</button>
    </div>
  </div>

  <div class="mt-2 shadow">
    <div class="barLoader" v-if="isLoader"></div>
    <CroppingCalendarMapVue :regions="regions" :allMonthActivities="cropData"></CroppingCalendarMapVue>

  </div>

  <!-- Floating Notification Card -->
  <div
    v-if="currentNotification"
    class="notification-floating-card"
    style="position: fixed; top: 50%; right: 30px; transform: translateY(-50%); width: 300px; z-index: 1050;"
  >
    <div class="card border-0 shadow-sm" style="border-left: 4px solid #ffc107 !important;">
      <div class="card-body p-3">
        <div class="d-flex align-items-start" @click="isNotificationExpanded = !isNotificationExpanded" style="cursor: pointer;">
          <div class="notification-icon bg-warning text-white me-2 position-relative">
            <i class="bi bi-bell"></i>
            <span v-if="notifications.length > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style="font-size: 10px;">
              {{ notifications.length }}
            </span>
          </div>
          <div class="flex-grow-1 text-start">
            <h6 class="fw-bold mb-0" style="font-size: 14px;">{{ currentNotification.label }}</h6>
          </div>
          <i class="bi" :class="isNotificationExpanded ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        </div>
        <div v-if="isNotificationExpanded" class="mt-2">
          <p class="small text-muted mb-1" style="font-size: 12px;">{{ currentNotification.description }}</p>
          <p v-if="currentNotification.resolution" class="small text-success mb-0" style="font-size: 12px;">
            <i class="bi bi-check-circle me-1"></i>{{ currentNotification.resolution }}
          </p>
          <div v-if="notifications.length > 1" class="d-flex justify-content-between align-items-center mt-2">
            <small class="text-muted">{{ notificationIndex + 1 }} / {{ notifications.length }}</small>
            <div @click.stop>
              <button class="btn btn-sm btn-outline-secondary me-1" @click="prevNotification" :disabled="notificationIndex === 0">
                <i class="bi bi-chevron-left"></i>
              </button>
              <button class="btn btn-sm btn-outline-secondary" @click="nextNotification" :disabled="notificationIndex === notifications.length - 1">
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="offcanvas offcanvas-end" v-if="region" tabindex="-1" id="resources" aria-labelledby="offcanvasExampleLabel">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel">Resources</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body text-start">
      <div>
        <h5>Bundle Services</h5>
        <div class="card my-2" v-for="(bundle_service, i) in region.bundle_services" :key="i">
          <div class="card-body">
            <ul class="list-group list-group-flush" style="font-size:13px" v-for="(service, key) in bundle_service"
              :key="key">
              <li class="list-group-item py-0 d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                  <div class="fw-bold">{{ key.replace(/_/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() +
                    word.slice(1)).join(' ') }}</div>
                  <span class="text-muted">{{ service }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br>
  <br>
  <br>
</template>

<script>
// @ is an alias to /src
import axios from "axios"
import CroppingCalendarMapVue from "../components/croppingCalendarMap.vue"
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  name: "CroppingCalendar",
  components: {
    CroppingCalendarMapVue,
  },
  data() {
    return {
      analyticsSrc:'https://analytics.miphost.com/js/script.js',
      analyticsDomain: 'aghub.miphost.com/main/croppingcalendarg',
      cc_count: 0,
      date: null,
      errMsg:'',
      notifications: [],
      currentNotification: null,
      notificationIndex: 0,
      isNotificationExpanded: false
    };
  },
  mounted() {
    this.viewCount();
    this.fetchNotifications();
  },
  beforeUnmount() {
  },
  created() {
    this.fetchCrops()
    this.fetchRegions()
    this.fetchLanguages()
    this.setMapComponentInstance(this)
  },
  computed: {
    ...mapState(['crops', 'regions', 'districts', 'selectedRegion', 'selectedCrop','selectedPlantingDate', 'selectedDistrict', 'cropData', 'cropDataActivities', 'selectedYear', 'selectedLanguage', 'languages']),
    ...mapGetters(['region','crop', 'isLoader']),
    onSelectedRegion: {
      get() {
        return this.selectedRegion;
      },
      set(value) {
        this.updateRegion(value);
      }
    },
    onSelectedDistrict: {
      get() {
        return this.selectedDistrict;
      },
      set(value) {
        this.updateDistrict(value);
      }
    },
    onSelectedCrop: {
      get() {
        return this.selectedCrop;
      },
      set(value) {
        this.updateCrop(value);
      }
    },
    onSelectedPlantingDate: {
      get() {
        return this.selectedPlantingDate;
      },
      set(value) {
        console.log('Setting Planting Date:', value);
        this.updatePlantingDate(value);
      }
    },
    onSelectedYear: {
      get() {
        return this.selectedYear;
      },
      set(value) {
        this.updateYear(value);
      }
    },
    onSelectedLanguage: {
      get() {
        return this.selectedLanguage;
      },
      set(value) {
        this.updateLanguage(value);
      }
    }
  },
  methods: {
    ...mapActions(['fetchCrops', 'fetchRegions', 'updateRegion', 'updateDistrict', 'updateCrop', 'updatePlantingDate', 'fetchLanguages', 'updateYear', 'updateLanguage']),
    ...mapMutations(['setMapComponentInstance']),

    viewCount(){
      axios.get('https://aghub.miphost.com/api/cc/count')
        .then(response => {
          console.log('View count:', response.data);
          this.cc_count = response.data.visits || 0;
        })
        .catch(error => {
          console.error('Error fetching view count:', error);
        });
    },
    async fetchNotifications() {
      try {
        const response = await axios.get('https://aghub.miphost.com/api/cc/notifications/visible');
        this.notifications = response.data;
        if (this.notifications.length > 0) {
          this.currentNotification = this.notifications[0];
          this.notificationIndex = 0;
        }
      } catch (error) {
        console.log('Error fetching notifications:', error);
      }
    },
    nextNotification() {
      if (this.notificationIndex < this.notifications.length - 1) {
        this.notificationIndex++;
        this.currentNotification = this.notifications[this.notificationIndex];
      }
    },
    prevNotification() {
      if (this.notificationIndex > 0) {
        this.notificationIndex--;
        this.currentNotification = this.notifications[this.notificationIndex];
      }
    },
     handleDate(modelData){
      console.log('Selected date:', modelData);
      this.date = modelData;
    }

  },
  watch: {

  }
};
</script>


<style scoped>
select.form-select::-ms-expand {
  display: none !important;
}

/* Style the Bootstrap icon that replaces the arrow */
.form-select::after {
  display: none;
}

.notification-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}


.form-control,
.form-select {
  height: 30px !important;
  min-height: unset;
  font-size: 0.88rem !important;
  background-color: #cfcfcf !important;
  border: none;
}

.bg-pink {
  background-color: rgb(43, 82, 7) !important;
}

.col .activites {
  width: min-content !important;
}

label {
  font-weight: 400 !important;
  font-size: 13px !important;
  font-family: 'Open Sans', sans-serif !important;
}



.rounded-5 {
  border-radius: 15px !important;
}

.rounded-4 {
  border-radius: 10px !important;
}

* {
  box-sizing: border-box;
}

.form-check-input:disabled {
  opacity: 1 !important;
}

.form-check-input {
  border: none;
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
  opacity: 1 !important;
}



.shadow {
  box-shadow: 0.3rem 0.2rem 0.5rem rgba(0, 0, 0, .15) !important;
}

.card:hover {
  box-shadow: 0.3rem 0.2rem 0.5rem rgba(0, 0, 0, 0.251) !important;
}

.form-select {
  background-color: #ffffffb9;
  font-size: 0.8rem;
  color: rgb(43, 40, 40);
  font-weight: 500;
}

.form-select option {
  background-color: rgba(255, 255, 255, 0.521);
  border-radius: 2px;
  opacity: 0.5;
}

.form-select:focus {
  border-color: #86b7fe40;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 3%);
}


</style>

<style lang="css" scoped>
.dp__theme_light {
    --dp-background-color: #cfcfcf ;
    --dp-text-color: #000000;
    --dp-hover-color: #f3f3f3;
    --dp-hover-text-color: #212121;
    --dp-hover-icon-color: #959595;
    --dp-primary-color: #1976d2;
    --dp-primary-disabled-color: #6bacea;
    --dp-primary-text-color: #f8f5f5;
    --dp-secondary-color: #c0c4cc;
    --dp-border-color: #ddd;
    --dp-menu-border-color: #ddd;
    --dp-border-color-hover: #aaaeb7;
    --dp-border-color-focus: #aaaeb7;
    --dp-disabled-color: #f6f6f6;
    --dp-scroll-bar-background: #f3f3f3;
    --dp-scroll-bar-color: #959595;
    --dp-success-color: #76d275;
    --dp-success-color-disabled: #a3d9b1;
    --dp-icon-color: #2c2c2c;
    --dp-danger-color: #ff6f60;
    --dp-marker-color: #ff6f60;
    --dp-tooltip-color: #fafafa;
    --dp-disabled-color-text: #8e8e8e;
    --dp-highlight-color: rgb(25 118 210 / 10%);
    --dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);
    --dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);
    --dp-range-between-border-color: var(--dp-hover-color, #f3f3f3);
}


</style>